export default __webpack_public_path__ + "static/media/dp.a9136072.png";